(() => {
  const methods = ['espresso', 'v60', 'aeropress', 'cafetiere', 'moka-pot', 'filter-machine'];
  const guideURL = (method, coffee) => {
    const url = new URL(`/pages/${method}-brew-guide`, location.origin);
    if (coffee) url.searchParams.set('coffee', coffee);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search;
  };
  const initialize = scope => {
    scope.querySelectorAll('[data-brew-directory]').forEach(directory => {
      if (directory.dataset.initialized) return;
      directory.dataset.initialized = 'true';
      directory.querySelectorAll('[data-brew-filter]').forEach(button => button.addEventListener('click', () => {
        directory.querySelectorAll('[data-brew-filter]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        directory.querySelectorAll('[data-brew-category]').forEach(card => { card.hidden = button.dataset.brewFilter !== 'all' && card.dataset.brewCategory !== button.dataset.brewFilter; });
      }));
    });
    scope.querySelectorAll('[data-brew-widget]').forEach(widget => {
      if (widget.dataset.initialized) return;
      widget.dataset.initialized = 'true';
      const selector = widget.querySelector('[data-brew-coffee]');
      let coffee = widget.dataset.coffee;
      let method = widget.dataset.method;
      if (selector) {
        const requested = new URL(location.href).searchParams.get('coffee');
        if ([...selector.options].some(option => option.value === requested)) selector.value = requested;
        coffee = selector.value;
      }
      const update = () => {
        widget.querySelectorAll('[data-brew-recipe]').forEach(panel => { panel.hidden = panel.dataset.method !== method || panel.dataset.coffee !== coffee; });
        widget.querySelectorAll('[data-brew-note]').forEach(note => { note.hidden = note.dataset.brewNote !== coffee; });
        widget.querySelectorAll('[data-brew-method]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.brewMethod === method)));
        const link = widget.querySelector('[data-brew-guide-link]');
        if (link) link.href = guideURL(method, coffee);
        widget.querySelectorAll('[data-brew-other-link]').forEach(link => {
          const nextMethod = link.dataset.brewOtherLink;
          if (methods.includes(nextMethod)) link.href = guideURL(nextMethod, coffee);
        });
      };
      selector?.addEventListener('change', () => {
        coffee = selector.value;
        const url = new URL(location.href);
        url.searchParams.set('coffee', coffee);
        history.replaceState(history.state, '', url);
        update();
      });
      widget.querySelectorAll('[data-brew-method]').forEach(button => button.addEventListener('click', () => {
        if (!methods.includes(button.dataset.brewMethod)) return;
        method = button.dataset.brewMethod;
        update();
      }));
      widget.querySelectorAll('[data-brew-servings]').forEach(input => input.addEventListener('change', () => {
        const multiplier = Number(input.value) === 2 ? 2 : 1;
        widget.querySelectorAll('[data-brew-scale]').forEach(value => { value.textContent = String(Math.round(Number(value.dataset.base) * multiplier)); });
      }));
      const timer = widget.querySelector('[data-brew-timer]');
      if (timer) {
        const toggle = timer.querySelector('[data-timer-toggle]');
        const display = timer.querySelector('[data-timer-display]');
        let elapsed = 0, started = 0, interval = null;
        const render = () => {
          const seconds = Math.floor((elapsed + (interval ? Date.now() - started : 0)) / 1000);
          display.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
        };
        const pause = () => {
          if (interval) elapsed += Date.now() - started;
          clearInterval(interval);
          interval = null;
          toggle.textContent = elapsed ? 'Resume' : 'Start';
          toggle.setAttribute('aria-pressed', 'false');
          render();
        };
        toggle.setAttribute('aria-pressed', 'false');
        toggle.addEventListener('click', () => {
          if (interval) return pause();
          started = Date.now();
          interval = setInterval(render, 250);
          toggle.textContent = 'Pause';
          toggle.setAttribute('aria-pressed', 'true');
        });
        timer.querySelector('[data-timer-reset]').addEventListener('click', () => { pause(); elapsed = 0; toggle.textContent = 'Start'; render(); });
        window.addEventListener('pagehide', pause, { once: true });
        document.addEventListener('shopify:section:unload', event => { if (event.target.contains(timer)) pause(); });
      }
      update();
    });
  };
  if (!window.TypoBrewGuides) {
    window.TypoBrewGuides = { initialize };
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  }
  window.TypoBrewGuides.initialize(document);
})();
